export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8449.98c919a7.jpg";